export default __webpack_public_path__ + "static/Fly6-3b81817c6c4d958648f7b82e1f4bd428.mp3";